import * as Yup from "yup";
import { URL_REGEX, validationResult } from "./patterns";
import { runFlatFormSchema } from "./yupFormUtils";

const BLOCK_PAGE_URL_MAX_LENGTH = 2048;

function validateBlockPageUrlValue(url, { required = false } = {}) {
  const trimmed = String(url ?? "").trim();
  if (!trimmed) {
    if (required) return validationResult(false, "URL is required");
    return validationResult(true);
  }
  if (trimmed.length > BLOCK_PAGE_URL_MAX_LENGTH) {
    return validationResult(false, `URL must be ${BLOCK_PAGE_URL_MAX_LENGTH} characters or fewer`);
  }
  if (!URL_REGEX.test(trimmed)) {
    return validationResult(false, "Enter a valid http or https URL");
  }
  return validationResult(true);
}

export function validateCustomBlockPageForm({
  locationUrl,
  wafUrl,
  interruptUrl,
  editType,
} = {}) {
  const showLocation = !editType || editType === "location";
  const showWaf = !editType || editType === "waf";
  const showInterrupt = !editType || editType === "interrupt";

  const schema = Yup.object({
    locationUrl: showLocation
      ? Yup.string().test("locationUrl", function (value) {
          const result = validateBlockPageUrlValue(value, { required: editType === "location" });
          return result.valid || this.createError({ message: result.message });
        })
      : Yup.mixed().optional(),
    wafUrl: showWaf
      ? Yup.string().test("wafUrl", function (value) {
          const result = validateBlockPageUrlValue(value, { required: editType === "waf" });
          return result.valid || this.createError({ message: result.message });
        })
      : Yup.mixed().optional(),
    interruptUrl: showInterrupt
      ? Yup.string().test("interruptUrl", function (value) {
          const result = validateBlockPageUrlValue(value, { required: editType === "interrupt" });
          return result.valid || this.createError({ message: result.message });
        })
      : Yup.mixed().optional(),
    form: Yup.mixed().test("form", function () {
      if (editType) return true;
      const hasAny = [locationUrl, wafUrl, interruptUrl].some((url) => String(url ?? "").trim() !== "");
      if (!hasAny) {
        return this.createError({ message: "Enter at least one custom block page URL" });
      }
      return true;
    }),
  });

  return runFlatFormSchema(schema, { locationUrl, wafUrl, interruptUrl, editType });
}
